// extracted by css-extract-rspack-plugin
export default {"cls1":"withPageLang-cls1_AXL","cls2":"withPageLang-cls2_qEH withPageLang-cls1_AXL"};